import { AreaSelectionState, initialAreaSelectionState } from "./area-selection.state";
import { AreaSelectionActions, AreaSelectionActionTypes } from "./area-selection.actions";

export function areaSelectionReducer(
  state = initialAreaSelectionState,
  action: AreaSelectionActions
): AreaSelectionState {
  switch (action.type) {
    case AreaSelectionActionTypes.SET_AREAS:
      return {
        ...state,
        areas: action.payload,
        loading: false
      };
    
    case AreaSelectionActionTypes.SET_SELECTED_AREA:
      return {
        ...state,
        selectedAreaId: action.payload
      };
    
    case AreaSelectionActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    
    default:
      return state;
  }
} 